<template>
  <div id="UploadWxQRCode">
    <el-dialog :center="true" title="微信二维码上传" :visible.sync="dialogVisible" width="980px">
      <div class="row-field">
        <div class="row-left">
          <span>微信扫码登录:</span>
        </div>
        <div class="row-right">
          <span v-if="openidPublic && openidPublic != ''">
            &nbsp;&nbsp;已绑定
          </span>
          <span v-else>
            &nbsp;&nbsp;未绑定
          </span>
        </div>
      </div>
      <div class="row-field">
        <div class="row-left">
          <span>微信昵称:</span>
        </div>
        <div class="row-right">
          <span v-if="openidPublic && openidPublic != ''">
            &nbsp;&nbsp;{{nickname}}
          </span>
        </div>
      </div>
      <div class="row-field">
        <div class="row-left">
          <span>本人微信二维码:</span>
        </div>
        <div class="row-right">
          <ebImgCropper id="wxQRCodeImg" ref="wxQrcodeUpload" @cropper-success="cropperSuccessHandle" :imgType="imgType"/>
        </div>
      </div>
      <div class="eb-button-group">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="dialogVisible = false">取消</el-button>
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirm()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import ebImgCropper from '@/components/common/eb-img-cropper';
import { uploadFile } from '@/plugins/upload-file';
export default {
  name: 'UploadWxQRCode',
  props: ['openidPublic', 'nickname'],
  components: {
    ebImgCropper
  },
  data() {
    return {
      dialogVisible: false,
      showName: '',
      userId: '',
      wxImgUrl: '/user/uploadWxQRCodeImg',
      imgType: 'wxQrcode'
    };
  },
  created() {
    eventBus.$on('uploadWxQRCode', (showName, userId) => {
      this.dialogVisible = true;
      this.showName = showName;
      this.userId = userId;
    });
  },
  methods: {
    cropperSuccessHandle(target, imgData) {
      let formData = {
        channel: 'qrcode',
        showName: this.showName,
        userId: this.userId,
        wxQRCodeImgCropper: imgData
      };
      uploadFile(
        target,
        this.wxImgUrl,
        formData,
        res => {
          let { data } = res;
          if (data.returnCode === '00') {
            this.$message.error('二维码上传失败！');
          } else {
            this.$parent.user.wxQRCodeImg = '';
            eventBus.$emit('loadUserInfo', 'wxQrcode');
            this.dialogVisible = false;
            this.$message.success('二维码上传成功！');
          }
        },
        complete => {}
      );
    },
    confirm() {
      this.$refs.wxQrcodeUpload.submit();
    }
  },
  beforeDestroy() {
    eventBus.$off('uploadWxQRCode');
  }
};
</script>
<style scoped lang="less">
#UploadWxQRCode {
  .row-field {
    width: 100%;
    line-height: 35px;
    min-height: 35px;
    margin-left: 0px;
    font-family: '微软雅黑';
    display: flex;
    flex-wrap: wrap;
    span {
      font-size: 1em;
      font-weight: bold;
    }
    .row-left {
      width: 13%;
      margin-left: 0px;
      margin-right: 15px;
    }
    .row-right {
      width: 84%;
    }
  }
}
</style>
